module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-12.540735bd.png";